// extracted by mini-css-extract-plugin
export var header = "_uc-1";
export var maskBottom = "_uc-6";
export var maskMiddle = "_uc-7";
export var maskTop = "_uc-5";
export var root = "_uc-0";
export var scrollDownButton = "_uc-3";
export var scrollDownButtonHidden = "_uc-4";
export var viewport = "_uc-2";